import './Pages.css'
import './About.css'


const hero = {
    image: '/images/group/_DSC6640b.jpg',
    mobileImage: '/images/group/_DSC6640b.jpg',
    imagePosition: 'center bottom'
}

function About() {
    return (
        <>
        <section className="about-hero">
            <picture>
                <source media="(max-width: 768px)" srcSet={hero.mobileImage} />
                <img
                    src={hero.image}
                    alt="Kazoku Quartet"
                    className="about-hero-img"
                    style={hero.imagePosition ? { objectPosition: hero.imagePosition } : undefined}
                />
            </picture>
            <div className="about-hero-overlay">
                <h1 className="about-hero-title">About Kazoku Quartet</h1>
                <div className="about-scroll-hint" aria-hidden="true">&#8595;</div>
            </div>
        </section>
        <div className="page">

            <div className="about-bio-wrap">
                <img
                    src="/images/group/_DSC6837.JPG"
                    alt="Kazoku Quartet"
                    className="about-float-img about-float-right"
                />
                <p>
                    Named after the Japanese word for "family," the Kazoku Quartet is a Houston-based classical saxophone ensemble whose programming bridges genres, cultures, and generations. Founded in 2017 by saxophonists Dan Gelok, Masahito Sugihara, Seth McAdow, and Evan Withner, the group was built on a foundation of musical excellence and a shared commitment to community engagement. Now featuring Scott Augustine on soprano saxophone, Kazoku Quartet continues to bring adventurous, accessible chamber music to audiences across Southeast Texas and beyond.
                </p>
            </div>

            <div className="about-bio-wrap">
                <img
                    src="/images/group/18.png"
                    alt="Kazoku Quartet"
                    className="about-float-img"
                />
                <p>
                    The ensemble moves fluidly between avant-garde contemporary works, historical Baroque transcriptions, and popular and incidental music, always prioritizing musical excellence regardless of idiom. The quartet regularly collaborates with living composers such as Rob Smith, Joel Love, and Anthony Brandt, and through a longstanding partnership with Houston's new music collective Musiqa, has performed works by Jennifer Higdon, William Bolcom, David Ludwig, Steve Reich, Marcus Maroney, James Primosch, Michael Daugherty, and dozens of others. In 2026 the quartet received a Houston Arts Alliance grant for "Houston Is Inspired," a project commissioning two large-scale works by Mark Buller and Kyle Kindred alongside over ten short compositions by students from the University of Houston, Sam Houston State University, Texas Southern University, and Houston Community College.
                </p>
            </div>

            <div className="about-bio-wrap">
                <img
                    src="/images/group/_DSC6708.JPG"
                    alt="Kazoku Quartet"
                    className="about-float-img about-float-right"
                />
                <p>
                    Beyond the concert hall, Kazoku Quartet is equally at home in art galleries, pubs, holiday markets, neighborhood parks, and school auditoriums. Their performances have taken them to the Contemporary Arts Museum Houston (CAMH), POST Houston, MATCH, and university stages at Baylor, Lamar, Sam Houston State, and the University of Houston, among many others. The group was invited to perform for Mayor Sylvester Turner's reception hosting Princess Astrid of Belgium, and their Harvey Relief Concert at MATCH in September 2017 set the tone for a group whose identity is rooted in showing up for their community. They regularly bring chamber music to young students through educational residencies, summer band camps, and masterclass tours across the greater Houston area.
                </p>
            </div>

            <div className="about-bio-wrap">
                <p>
                    Individually, the members of Kazoku Quartet maintain active careers as performers and educators. They hold or have held faculty positions at the University of Houston, Sam Houston State University, and Lone Star College, and perform regularly with the Houston Symphony, the Houston Ballet, and the Singapore Symphony Orchestra. Each brings a distinct musical voice, but together they create something deeply unified and personal.
                </p>
            </div>

            <p className="about-media-pack">
                <a href="/media/kazoku-media-pack.zip" download>Download Media Pack</a>
            </p>

        </div>
        </>
    );
}

export default About; 